import { footerData } from './mock/footerMock.js';

angular.module('Toke').factory('footerRepository', function ($q) {

    function getFooter() {
        return $q.resolve(footerData)
    }

    // para lista futura
    // function getFooterFromList() {

    //     const listUrl =
    //         baseUrl +
    //         "/_api/web/lists/getbytitle('Navbar')/items" +
    //         "?$select=Title,Url,ParentId,Order,IsActive" +
    //         "&$orderby=Order asc";

    //     return $http({
    //         method: 'GET',
    //         url: listUrl,
    //         headers: {
    //             Accept: 'application/json;odata=nometadata'
    //         }
    //     }).then(function (response) {
    //         return response.data.value;
    //     });
    // }



    return {
        getFooter: getFooter
    };

});

